module.exports = __webpack_public_path__ + "static/media/animais.e2bb45da.png";